<template>
  <div class="collection-container">
    <a-radio-group v-model:value="state.lang">
      <a-radio-button
        v-for="lang in state.langList"
        :key="lang.value"
        :value="lang.value"
        >{{ lang.label }}</a-radio-button
      >
    </a-radio-group>
    <div class="EditContainer mt20" v-if="currentLang">
      <a-form layout="vertical">
        <a-form-item label="默认币种">
          {{ state.defaultCurrency }}
        </a-form-item>
        <a-form-item label="场景" required>
          <a-select
            v-model:value="state.data.scene"
            :disabled="state.lang !== state.defaultLang"
          >
            <a-select-option
              v-for="(item, key) in state.sceneDic"
              :value="item.value"
              :key="key"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="场景开关" required>
          <a-switch
            v-model:checked="state.data.sceneSwitch"
            :checkedValue="1"
            :unCheckedValue="0"
            checked-children="开"
            un-checked-children="关"
            :disabled="state.lang !== state.defaultLang"
          >
          </a-switch>
        </a-form-item>
        <a-form-item label="人群" required>
          <a-select
            v-model:value="state.data.personGroup"
            :disabled="state.lang !== state.defaultLang"
          >
            <a-select-option
              v-for="(item, key) in state.personGroupDic"
              :value="item.value"
              :key="key"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="页面停留时间（单位：秒）" class="w500" required>
          <a-input
            class="w300"
            placeholder="请输入"
            v-model:value="state.data.durationOnPage"
            :disabled="state.lang !== state.defaultLang"
          ></a-input>
        </a-form-item>
        <a-form-item label="弹窗类型" required>
          <a-select
            v-model:value="state.data.popupType"
            :disabled="state.lang !== state.defaultLang"
          >
            <a-select-option
              v-for="(item, key) in state.popupTypeDic"
              :value="item.value"
              :key="key"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </a-form-item>
        <a-form-item label="弹窗样式" required>
          <a-select
            v-model:value="state.data.style"
            :disabled="state.lang !== state.defaultLang"
          >
            <a-select-option :value="1">样式一</a-select-option>
            <a-select-option :value="2">样式二</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="弹出间隔（单位：天）" class="w500" required>
          <a-input
            class="w300"
            :disabled="state.lang !== state.defaultLang"
            v-model:value="state.data.popupInterval"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item label="弹出次数限制" class="w500" required>
          <a-input
            class="w300"
            :disabled="state.lang !== state.defaultLang"
            v-model:value="state.data.countLimit"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item label="弹窗图片" class="w500">
          <div class="w80 h80 mb10 pr alertUpload">
            <div class="w80 h80 mb10 pr alertUpload">
              <a-upload-dragger
                :fileList="[]"
                :show-upload-list="false"
                name="file"
                :multiple="true"
                :customRequest="upload"
                :accept="'.png,.jpg,.jpeg,.gif'"
                :headers="state.uploadHeaders"
              >
                <div v-if="!currentLang.popupImageUrl">
                  <div
                    class="w80 h80 tac"
                    style="color: #999999; font-size: 40px; line-height: 80px;"
                  >
                    <PictureOutlined />
                  </div>
                </div>
              </a-upload-dragger>
              <div
                v-if="currentLang.popupImageUrl"
                class="h80 pa l0 t0 sidebarContentBg"
                :style="
                  `width: 80px; background: url('${currentLang.popupImageUrl}') center center/ cover no-repeat;`
                "
              >
                <div class="hover alertPicHover">
                  <DeleteOutlined @click="currentLang.popupImageUrl = null" />
                </div>
              </div>
            </div>
          </div>
        </a-form-item>
        <a-form-item
          label="订单金额区间"
          required
          v-if="state.data.scene !== 4 && state.data.personGroup === 2"
        >
          <a-row>
            <a-col>
              <a-input-number
                class="mr10"
                :disabled="state.lang !== state.defaultLang"
                v-model:value="state.data.orderMinAmount"
                :min="0"
                :formatter="formatNumber"
                :max="9999"
              ></a-input-number
              >——</a-col
            >
            <a-col class="ml10">
              <a-input-number
                :disabled="state.lang !== state.defaultLang"
                v-model:value="state.data.orderMaxAmount"
                :formatter="formatNumber"
                :min="0"
                :max="9999"
              ></a-input-number
            ></a-col>
          </a-row>
        </a-form-item>
        <a-form-item
          label="弹窗提示文案"
          class="w500"
          v-if="currentLang"
          required
        >
          <a-input
            class="w300"
            v-model:value="currentLang.popupCopywriting"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item label="弹窗button文案" class="w500" required>
          <a-input
            class="w300"
            v-model:value="currentLang.btnCopywriting"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item
          label="跳转链接"
          class="w500"
          v-if="state.data.popupType == 2"
          required
        >
          <a-input
            class="w300"
            :disabled="state.lang !== state.defaultLang"
            v-model:value="state.data.linkUrl"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item
          label="是否展示倒计时"
          required
          v-if="state.data.style == 2"
        >
          <a-select
            v-model:value="state.data.countdownSwitch"
            :disabled="state.lang !== state.defaultLang"
          >
            <a-select-option :value="1">启用</a-select-option>
            <a-select-option :value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item
          label="倒计时时长（单位：秒）"
          class="w500"
          v-if="state.data.countdownSwitch == 1"
        >
          <a-input
            class="w300"
            v-model:value="state.data.countdownSecond"
            placeholder="请输入"
            :disabled="state.lang !== state.defaultLang"
          />
        </a-form-item>
        <a-form-item
          label="活动事件名称"
          class="w500"
          required
          v-if="state.data.popupType == 1"
        >
          <a-input
            class="w300"
            :disabled="state.lang !== state.defaultLang"
            v-model:value="state.data.activityEvent"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item label="弹窗复制内容" class="w500" required>
          <a-input
            class="w300"
            v-model:value="currentLang.copyCopywriting"
            placeholder="请输入"
          />
        </a-form-item>
        <a-form-item
          label="日程区间"
          class="w500"
          required
          v-if="state.data.scene === 4"
        >
          <a-range-picker
            class="w400"
            showTime
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            @change="onChange"
            v-model:value="state.data.time"
            @ok="onOk"
          />
        </a-form-item>
        <a-form-item
          label="日程标题"
          class="w500"
          required
          v-if="state.data.scene === 4"
        >
          <a-input
            class="w300"
            v-model:value="state.data.calendarTitle"
            placeholder="请输入"
            :disabled="state.lang !== state.defaultLang"
          />
        </a-form-item>
        <a-form-item
          label="日程描述"
          class="w500"
          required
          v-if="state.data.scene === 4"
        >
          <a-input
            class="w300"
            v-model:value="state.data.calendarDesc"
            placeholder="请输入"
            :disabled="state.lang !== state.defaultLang"
          />
        </a-form-item>
      </a-form>
    </div>
    <div class="tar w500 pt40">
      <a-button class="mr10" type="default" @click="() => jumpPage()"
        >返回</a-button
      >
      <a-button type="primary" @click="() => save()">保存</a-button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
// import useAPI from 'UseApi'
// import { message } from 'ant-design-vue'
// import { formRequest } from 'cupshe-axios'
// import BigPic from './components/BigPic'
import {
  // common_queryCountryInfo_post,
  // common_querySiteInfo_post,
  // common_queryStateInfo_post,
  // common_queryLanguageInfo_post,
  common_uploadFile_post,
  // common_querySiteInfo_get,
  common_lang_get
} from 'server/modules/3426'
import {
  autoPopup_detail_id_get,
  autoPopup_edit_post,
  autoPopup_add_post
} from 'server/modules/10167'
import { PictureOutlined, DeleteOutlined } from '@ant-design/icons-vue'

const route = useRoute()
const router = useRouter()

const { id, uniqueId } = route.query

const formatNumber = value => {
  if (!value) return ''
  const intValue = parseInt(value)
  return Number.isNaN(intValue) ? '' : String(intValue)
}
const jumpPage = () => {
  router.push({
    path: 'AlertManageList',
    query: { uniqueId }
  })
}

const save = async () => {
  const api = id ? autoPopup_edit_post : autoPopup_add_post
  if (state.data.scene !== 4 && state.data.personGroup === 2) {
    if (state.data.orderMinAmount >= state.data.orderMaxAmount) {
      return message.warning('金额区间前面不能大于后面区间')
    }
  }
  if (state.data.scene === 4 && !state.data.calendarTitle) {
    return message.warning('请填写日程标题')
  }
  if (state.data.scene === 4 && !state.data.calendarDesc) {
    return message.warning('请填写日程描述')
  }
  if (state.data.scene === 4 && !state.data.calendarEndDatetime) {
    return message.warning('请选择日程区间')
  }
  const { success, retInfo } = await api(
    Object.assign(
      state.data,
      id
        ? {
            id,
            uniqueId
          }
        : { uniqueId }
    )
  )
  if (success) {
    message.success('保存成功')
    jumpPage()
  } else {
    message.error(retInfo)
  }
}

const state = reactive({
  langList: [],
  defaultLang: '',
  lang: '',
  defaultCurrency: '',
  data: {
    personGroup: null,
    scene: null,
    popupType: null,
    sceneSwitch: null,
    countLimit: null,
    popupInterval: null,
    durationOnPage: null,
    popupCopywriting: null,
    btnCopywriting: null,
    linkUrl: '',
    activityEvent: '',
    style: null,
    copyCopywriting: null,
    countdownSwitch: null,
    countdownSecond: null,
    orderMinAmount: null,
    orderMaxAmount: null,
    calendarTitle: null,
    calendarDesc: null,
    calendarStartDatetime: null,
    calendarEndDatetime: null,
    time: [],
    langs: []
  },
  sceneDic: [
    { value: 1, label: 'PDP' },
    { value: 2, label: 'Checkout' },
    { value: 3, label: 'Add to bag' },
    { value: 4, label: '活动日程' }
  ],
  personGroupDic: [
    { value: 1, label: '浏览未购' },
    { value: 2, label: '结算未购' },
    { value: 3, label: '加车未结算' },
    { value: 4, label: '支付成功' }
  ],
  popupTypeDic: [
    { value: 1, label: '优惠券发放' },
    { value: 2, label: '链接跳转' },
    { value: 3, label: '复制' },
    { value: 4, label: '日程提醒' }
  ],
  uploadHeaders: {
    Authorization:
      localStorage.getItem('token') || '0e044f64c5364f93a5cb83731a09b8b9'
  }
})

const upload = async info => {
  const { file } = info
  const isLtMaxM = file.size / 1024 <= 50
  if (isLtMaxM) {
    const formData = new FormData()
    formData.append('file', file)
    const { data } = await common_uploadFile_post(formData)
    currentLang.value.popupImageUrl = data
  } else {
    message.error('图片大小不能超过50KB')
  }
}

const initCommonLang = async () => {
  const { data } = await common_lang_get({ uniqueId })
  state.langList = Object.entries(data.languageMap).map(([key, value]) => ({
    label: key,
    value
  }))
  state.defaultLang = data.defaultLanguageCode
  state.defaultCurrency = data.defaultCurrency || '未配置默认币种'
}

const initDetail = async () => {
  await initCommonLang()
  if (id) {
    const { data } = await autoPopup_detail_id_get({ id })
    state.data = data
    state.data.time = [
      dayjs(data.calendarStartDatetime),
      dayjs(data.calendarEndDatetime)
    ]
    state.lang = data.langs[0].langCode
  } else {
    state.data.langs = state.langList.map(item => ({
      langCode: item.value,
      popupCopywriting: '',
      btnCopywriting: '',
      copyCopywriting: '',
      popupImageUrl: ''
    }))
    state.lang = state.defaultLang
  }
}
const onChange = (date, dateString) => {
  state.data.calendarStartDatetime = dateString[0]
  state.data.calendarEndDatetime = dateString[1]
}

const currentLang = computed(() => {
  if (!state.data) return null
  return state.data.langs.find(item => item.langCode === state.lang)
})

onMounted(() => initDetail())
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}

.EditContainer {
  width: 300px;
}
</style>
<style>
.alertUpload .ant-upload.ant-upload-drag .ant-upload-btn {
  padding: 0;
}

.alertPicHover {
  text-align: center;
  line-height: 80px;
  color: #f8f8f8;
}
</style>
